














































































































































































































































































































































import { AccountManagerService, RoleRoleDTO } from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import LanguageComponent from "@/components/common/languageComponent.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import { PropType } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "AccountEditComponent",
  components: { QErrors, LanguageComponent, QUploadSingleImage },
})
export default class AccountEditComponent extends Vue {

  get contentLanguageComputed() {
    if (this.languages[this.contentLanguage] === true) {
      return this.contentLanguage;
    } else {
      return "ja";
    }
  }
  @Prop({
    required: true,
    type: Array as PropType<RoleRoleDTO[]>,
  })
  public roles;

  public isShow = false;
  public mode = "create";
  public errors = {};

  public data = {
    id: null,
    name: "",
    name_en: "",
    name_cn: "",
    email: null,
    kana: null,
    role_id: 1,
    password: null,
    password_confirmation: null,
    image_id: null,
    image: null,
    is_viewable: false,
    comment: null,
    comment_en: null,
    comment_cn: null,
    sort_order: null,
    created_at: null,
  };

  public origin: any = { ...this.data };

  public languages = {
    ja: true,
    en: true,
    cn: false,
  };

  public contentLanguage = LANG.JA;

  public uploading = false;

  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };

  public show(id) {
    this.reset();
    this.errors = {};

    if (id) {
      this.mode = "edit";
      this.data.id = id;
      this.detail();
    } else {
      this.mode = "create";
    }

    this.origin = { ...this.data };
    this.isShow = true;
  }

  public async reset() {
    this.contentLanguage = LANG.JA;

    this.data = {
      id: null,
      name: "",
      name_en: "",
      name_cn: "",
      email: null,
      kana: null,
      role_id: 1,
      password: null,
      password_confirmation: null,
      image_id: null,
      is_viewable: false,
      comment: null,
      comment_en: null,
      comment_cn: null,
      sort_order: null,
      created_at: null,
      image: null,
    };
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: this.$t("common.message.delete_confirm"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.delete();
        this.isShow = false;
        this.$emit("close");
      },
    });
  }

  public confirmCancel() {
    if (JSON.stringify(this.origin) === JSON.stringify(this.data)) {
      this.isShow = false;
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
      });
    }
  }

  public async delete() {
    this.errors = {};
    let result;
    try {
      result = await AccountManagerService.adminAccountDelete({
        id: this.data.id,
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  public async detail() {
    try {
      const { data } = await AccountManagerService.adminAccountShow({
        id: this.data.id,
      });

      this.data = {
        id: data.account.id,
        name: data.account.name,
        name_en: data.account.name_en,
        name_cn: data.account.name_cn,
        email: data.account.email,
        kana: data.account.kana,
        role_id: data.account.role ? data.account.role.id : null,
        image_id: data.account.image_id,
        image: data.account.image,
        is_viewable: data.account.is_viewable,
        comment: data.account.comment,
        comment_en: data.account.comment_en,
        comment_cn: data.account.comment_cn,
        sort_order: data.account.sort_order,
        created_at: data.account.created_at,
        password: null,
        password_confirmation: null,
      };

      this.origin = { ...this.data };
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
    }
  }

  public async submit() {
    this.errors = {};
    let result;
    try {
      if (this.mode == "create") {
        result = await AccountManagerService.adminAccountCreate(this.data);
      } else {
        result = await AccountManagerService.adminAccountEdit(this.data);
      }
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
      if ("comment" in this.errors) {
        this.contentLanguage = LANG.JA;
      } else if ("comment_en" in this.errors) {
        this.contentLanguage = LANG.EN;
      } else if ("comment_cn" in this.errors) {
        this.contentLanguage = LANG.CN;
      }
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  public changeFile(file) {
    this.data.image_id = file ? file.id : null;
    this.data.image.id = file ? file.id : null;
    this.data.image.name = file ? file.filePath : null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }
  public uploadStatus(flag) {
    this.uploading = flag;
  }
}
